import { TIPTAP_LINK_BUTTON_TYPE, TIPTAP_ACTION_BUTTON_TYPE } from 'ricos-content';
import buttonDataDefaults from 'ricos-schema/dist/statics/button.defaults.json';
import { createRicosNodeExtension } from 'wix-rich-content-plugin-commons';
import { LINK_BUTTON_TYPE, ACTION_BUTTON_TYPE } from '../types.js';
import { Button } from './component.js';
import 'react';
import '../viewer/button-viewer.js';
import 'ricos-schema';
import 'wix-rich-content-common';
import '../style-inject.es-e7b07dd7.js';
import '../dataHooks.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const getButtonExtension = (name) => [
  createRicosNodeExtension({
    groups: ["overlay", "resizable", "draggable", "not-overtypable"],
    type: "react-node",
    reconfigure: (config, _extensions, _props, settings) => __spreadProps(__spreadValues({}, config), {
      addOptions: () => settings
    }),
    Component: Button,
    name,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block",
        selectable: true,
        draggable: true,
        addAttributes: () => buttonDataDefaults
      };
    }
  })
];
const tiptapExtensionsMap = {
  [LINK_BUTTON_TYPE]: getButtonExtension(TIPTAP_LINK_BUTTON_TYPE),
  [ACTION_BUTTON_TYPE]: getButtonExtension(TIPTAP_ACTION_BUTTON_TYPE)
};

export { tiptapExtensionsMap };
//# sourceMappingURL=tiptap.js.map
